import React, { useState, useRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import useMount from 'react-use/lib/useMount';
import qs from 'qs';
import { iframeResizer } from 'iframe-resizer';
import { isEmpty } from 'lodash-es';

const Iframe = ({ className, src, title }) => {
  const [params, setParams] = useState({});
  const iframeRef = useRef();

  useMount(() => {
    if (document.referrer) setParams({ referrer: document.referrer });

    // If we have query params, add them to inputs that will be sent to Pardot
    const queryParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    if (!isEmpty(queryParams))
      setParams(currentParams => ({ ...currentParams, ...queryParams }));

    // Initialize iFrame resizer
    iframeResizer(
      {
        heightCalculationMethod: 'lowestElement',
        warningTimeout: 0,
        log: false,
      },
      iframeRef.current
    );
  });

  const classes = cx('iframe-container', className);

  return (
    <iframe
      className={classes}
      ref={iframeRef}
      src={`${src}?${qs.stringify(params)}`}
      title={title}
      scrolling="no"
    />
  );
};

Iframe.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Iframe;
